module.exports = __webpack_public_path__ + "img/lt.68bbe49e.svg";